import React from 'react';

export default function AmountWithCurrency({ amount, currency }) {
  const parsed = parseFloat(amount);

  return (
    <>
      {Number.isNaN(parsed)
        ? '-'
        : parsed.toLocaleString(undefined, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
      {currency && !Number.isNaN(parsed) && (
        <span style={{ fontSize: '0.60rem', fontStyle: 'italic' }}>
          {currency}
        </span>
      )}
    </>
  );
}
